import {
    addAction, addFilter, applyFilters, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    const newStyle = {};
    newStyle['full-height'] = () => `${window.innerHeight - applyFilters('header-height')}px`;
    addFilter('css-vars/register', (styles) => ({ ...styles, ...newStyle }));
});
